'use client';

import { c as _c } from "react/compiler-runtime";
import { CHALLENGE_HOST_CLASS } from '@spa/lib/fastly-challenge/challengeHost';
import GlobalErrorComponent from '@spa/components/global-error/global-error.component';
import IntlProvider from '@spa/lib/i18n/client/components/intl.provider';
import { NextError } from '@spa/components/global-error-debug/global-error-debug.component';
import { ReactNode } from 'react';
import deTranslations from './global-error-de.json';
import defaultLocale from '@spa/lib/configs/defaultLocale';
import enTranslations from './global-error-en.json';
export default function GlobalError(t0) {
  const $ = _c(7);
  const {
    error
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <head><title>Unerwarteter Fehler</title><meta name="viewport" content="width=device-width, initial-scale=1" /></head>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      de: deTranslations,
      en: enTranslations
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== error) {
    t3 = <IntlProvider translationsByIdByNamespace={t2} enableWarnings={false}><GlobalErrorComponent error={error} /></IntlProvider>;
    $[2] = error;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className={CHALLENGE_HOST_CLASS} />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3) {
    t5 = <html lang={defaultLocale}>{t1}<body>{t3}{t4}</body></html>;
    $[5] = t3;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
}